import { Modal, Stack, Title, Text, Button } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

type ModalMessageType = {
  title?: string;
  subtitle?: string;
  description?: string;
  no?: string;
  yes?: string;
};

interface propsDeleteModal {
  opened: boolean;
  onClose: () => void;
  onSuccess: () => void;
  modalMessage?: Partial<ModalMessageType>;
}

export const DeleteModal = ({ opened, onClose, onSuccess, modalMessage }: propsDeleteModal) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const onLocalSuccess = async () => {
    setLoading(true);
    await onSuccess();
    setLoading(false);
  };
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={modalMessage?.title || t('modals.delete_modal.title')}
    >
      <Stack>
        <Title order={3} style={{ textAlign: 'center' }}>
          {modalMessage?.subtitle || t('modals.delete_modal.are_you_sure')}
        </Title>
        <Text style={{ textAlign: 'center' }}>
          {modalMessage?.description || t('modals.delete_modal.description')}
        </Text>
      </Stack>
      <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '24px' }}>
        <Button
          variant="outline"
          onClick={onClose}
          disabled={loading}
          style={{
            cursor: loading ? 'wait' : 'pointer',
          }}
        >
          {modalMessage?.no || t('modals.delete_modal.no')}
        </Button>
        <Button
          onClick={onLocalSuccess}
          disabled={loading}
          style={{
            cursor: loading ? 'wait' : 'pointer',
          }}
        >
          {modalMessage?.yes || t('modals.delete_modal.yes')}
        </Button>
      </div>
    </Modal>
  );
};
